import React, { useState } from "react";
import { Button } from "@mui/material";
import HarshEventNotesDialog from "../HarshEventNotesDialog/HarshEventNotesDialog";

interface HarshEventNotesButtonProps {
  harshEventId: string;
}

const HarshEventNotesButton: React.FC<HarshEventNotesButtonProps> = ({
  harshEventId,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button variant="outlined" size="small" onClick={() => setOpen(true)}>
        Notes
      </Button>
      <HarshEventNotesDialog
        open={open}
        onClose={() => setOpen(false)}
        harshEventId={harshEventId}
      />
    </>
  );
};

export default HarshEventNotesButton;
